// The history entries behind the trial error route are all re-entrant: Trimble's hosted
// pages, our /callback (which re-links and lands on "no organization"), and the return leg
// of /register-public (which auto-submits provisioning again). None of them can be removed
// from the stack, so instead they read this marker and refuse to re-run for a visitor whose
// trial has already terminally failed in this tab.
const STORAGE_KEY = "dc:trial-signup-failed";

export const TRIAL_ERROR_PATH = "/register-public/error";
export const SUPPORT_NOTIFIED_PARAM = "notified";

// Rides the URL so it survives the refresh the error route exists to handle.
export function buildTrialErrorPath(supportNotified: boolean): string {
  return supportNotified ? `${TRIAL_ERROR_PATH}?${SUPPORT_NOTIFIED_PARAM}=1` : TRIAL_ERROR_PATH;
}

export type TrialSignupFailure = { supportNotified: boolean };

export function markTrialSignupFailed(supportNotified: boolean): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, supportNotified ? "1" : "0");
  } catch {
    // Private browsing and blocked site data throw here. Back stays re-entrant, which is
    // the behaviour we already had.
  }
}

export function readTrialSignupFailure(): TrialSignupFailure | null {
  if (typeof window === "undefined") return null;
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    return stored === null ? null : { supportNotified: stored === "1" };
  } catch {
    return null;
  }
}

export function clearTrialSignupFailure(): void {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // See markTrialSignupFailed.
  }
}
